<div class="modal-content">
    <div class="modal-header">
        @if (isDeleteFieldMap) {
            <h4 class="modal-title fw-bold">{{ 'study-editor.field-map.delete.environments.title' | translate }}</h4>
            <button type="button" class="btn-close" (click)="cancel()"></button>
        } @else {
            <h4 class="modal-title">{{ 'study-editor.field-map.select.environments.title' | translate }}</h4>
            <button type="button" class="btn-close" (click)="cancel()"></button>
        }
    </div>
    <div class="modal-body">
        <div class="row col-sm-12">
        @if (isDeleteFieldMap) {
            <span class="col-form-label" jhiTranslate="study-editor.field-map.delete.environments.label"></span>
        } @else {
            <span class="col-form-label" jhiTranslate="study-editor.field-map.select.environments.label"></span>
        }
        </div>
        <ng-container>
            <div class="container-fluid px-0">
                <div class="table-responsive custom-scroll-style" style="max-height: 350px; overflow-y: auto; overflow-x: auto;">
                    <table class="table table-striped table-bordered table-curved table-fixed mb-0">
                        <thead class="sticky-header">
                            <tr>
                                <th></th>
                                <th>{{ 'study-editor.field-map.trial.instance.header' | translate }}</th>
                                <th>{{ 'study-editor.field-map.location.name.header' | translate }}</th>
                                <th>{{ 'study-editor.field-map.no.of.entries.header' | translate }}</th>
                                <th>{{ 'study-editor.field-map.no.of.reps.header' | translate }}</th>
                                <th>{{ 'study-editor.field-map.total.plots.header' | translate }}</th>
                                @if (!isViewFieldMap) {
                                <th>{{ 'study-editor.field-map.has.field.map.header' | translate }}</th>
                                <th>{{ 'study-editor.field-map.has.means.header' | translate }}</th>
                                <th>{{ 'study-editor.field-map.has.georeference.header' | translate }}</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (info of environmentFieldmapInfoItems; track info.instanceId;) {
                                <tr>
                                    <td>
                                    @if (isViewFieldMap) {
                                        <input type="radio" class="form-check-input m-1" [disabled]="disableSelect(info)"
                                               [(ngModel)]="selectedInstanceId" [value]="info.instanceId" checked>
                                    } @else {
                                        <input type="checkbox" class="form-check-input m-1" [disabled]="disableSelect(info)"
                                               [(ngModel)]="info.isChecked">
                                    }
                                    </td>
                                    <td>{{info.instanceNumber}}</td>
                                    <td>{{info.locationName}}</td>
                                    <td>{{info.entriesCount}}</td>
                                    <td>{{info.replicatesCount}}</td>
                                    <td>{{info.plotsCount}}</td>
                                    @if (!isViewFieldMap) {
                                    <td>{{info.hasFieldMap ? 'Yes' : 'No'}}</td>
                                    <td>{{info.hasMeansData ? 'Yes' : 'No'}}</td>
                                    <td>{{info.hasGeoJSON ? 'Yes' : 'No'}}</td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isLoading">
            <span>{{ 'study-editor.common.cancel' | translate }}</span>
        </button>
        <button (click)="continue()" class="btn btn-primary" [disabled]="disableContinueButton()">
            <i *ngIf="isLoading" class="throbber throbber-btn"></i>
            <span class="ms-1">{{ 'study-editor.common.ok' | translate }}</span>
        </button>
    </div>
</div>
